export default __webpack_public_path__ + "968ebb646f66568f4ce4288228172a10.svg";